var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import mainTheme from './mainTheme';
var quizzesTheme = __assign(__assign({}, mainTheme), { name: 'Quiz Page Theme', breakpoints: {
        xs: 0,
        sm: 430,
        md: 868,
        lg: 992,
        xl: 1920
    }, layout: __assign(__assign({}, mainTheme.layout), { page: {
            containerWidth: 960,
            spacing: 'small'
        } }) });
export default quizzesTheme;
//# sourceMappingURL=quizzesTheme.js.map